import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useI18n } from "@/contexts/i18n";
import { Box } from "@gemini/core";
import { Carousel } from "@gemini/ui";
import { useRefsContext } from "@/contexts/ref";
import { useModal, useTestId } from "@/hooks";
import { Section } from "@/components/UI";
import { useRichMedias, MediaModal, MediaPreview, } from "@/components/Sections/RichMedias";
import { IS_SERVER, ModalIds } from "@/constants";
export const RichMedias = () => {
    const testId = useTestId("Sections.RichMedia");
    const { t } = useI18n();
    const { display, medias } = useRichMedias();
    const { richMediasRef } = useRefsContext();
    const [selectedMedia, setSelectedMedia] = useState();
    const { isOpen, toggle } = useModal(false, ModalIds.MEDIA);
    const hasOneMedia = (medias === null || medias === void 0 ? void 0 : medias.length) === 1;
    const onSelectMedia = (media) => {
        if (media.urlType === "MOVIE") {
            setSelectedMedia(media);
            toggle();
        }
        if (media.urlType === "VIRTUAL_TOUR" && !IS_SERVER) {
            window.open(media.url);
        }
    };
    if (!display)
        return null;
    return (_jsxs(Section, { ref: richMediasRef, id: "richMedia", testId: testId, hasPaddingRight: hasOneMedia, unsafeClassname: "HideOnPrint", children: [_jsx(Box, { display: "flex", overflow: ["hidden", "clip"], testId: `${testId}.Carousel`, paddingRight: {
                    "breakpoint.base": hasOneMedia ? "spacing.4" : "spacing.32",
                    "breakpoint.lg": "spacing.4",
                }, paddingTop: "spacing.6", justifyContent: hasOneMedia ? "center" : "flex-start", children: _jsx(Carousel, { itemsPerView: {
                        "breakpoint.base": 1,
                        "breakpoint.sm": 2,
                        "breakpoint.md": 2,
                        "breakpoint.lg": 2,
                        "breakpoint.xl": 3,
                        "breakpoint.xxl": 3,
                        "breakpoint.xxxl": 3,
                    }, arrowPosition: "outside", title: t("richMedia.title"), items: medias === null || medias === void 0 ? void 0 : medias.map((media) => ({
                        id: media.key,
                        item: (_jsx(MediaPreview, { media: media, onSelectMedia: onSelectMedia, BoxProps: {
                                maxWidth: {
                                    "breakpoint.sm": hasOneMedia ? "300px" : "inherit",
                                },
                            } }, media.key)),
                    })) }) }), selectedMedia && (_jsx(MediaModal, { media: selectedMedia, isOpen: isOpen, toggle: toggle }))] }));
};
